import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { TextareaComponent } from "@components/textarea/textarea.component";
import { ModalComponentMediator } from "~app/common/components/modal/modal-component-mediator";

export interface BetalningSkogsvardCommentData {
    betalningId: number;
    commentUpdatedCallback?: (betalningId: number, comment: string) => void;
    editComment: string;
    editMode: boolean;
}

@Component({
    selector: "rask-betalning-skogsvard-comment",
    templateUrl: "./betalning-skogsvard-comment.component.html",
    styleUrls: ["./betalning-skogsvard-comment.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TextareaComponent,
        FormsModule,
        ButtonComponent
    ]
})
export class BetalningSkogsvardCommentComponent {
    betalningId: number;
    comment: string;
    commentUpdatedCallback: (betalningId: number, comment: string) => void;
    editMode: boolean;
    isEdited = false;

    private readonly modalComponentMediator = inject(ModalComponentMediator);

    @Input() set data(value: BetalningSkogsvardCommentData) {
        this.betalningId = value.betalningId;
        this.comment = value.editComment;
        this.commentUpdatedCallback = value.commentUpdatedCallback;
        this.editMode = value.editMode;
    }

    abort() {
        this.close();
    }

    changeComment(editedComment: string) {
        this.isEdited = true;
        this.comment = editedComment;
    }

    close() {
        this.modalComponentMediator.getRef().close(null);
    }

    save() {
        if (this.commentUpdatedCallback) {
            this.commentUpdatedCallback(this.betalningId, this.comment);
        }
        this.close();
    }
}
